import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  CustomerSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { AppContext } from "../AppContext.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { CustomerService } from "../services/CustomerService.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
export class CustomerLookupHandler extends LookupHandler {
  static contextType = AppContext;
  constructor(companyCode, attribute_name, isExcludeMasterCustomer) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;

    if (isExcludeMasterCustomer != null && isExcludeMasterCustomer != undefined)
      this.isExcludeMasterCustomer = isExcludeMasterCustomer;
    else this.isExcludeMasterCustomer = false;
    let resetCriteria = new CustomerSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let customerLookupCriteria = new CustomerSearchCriteria();
    customerLookupCriteria.companyCode = this.companyCode;
    this.customerLookupCriteria = customerLookupCriteria;
    let lookupCriteriaView = CustomerLookupCriteraHandler(
      companyCode,
      customerLookupCriteria
    );
    let newCriteria = new CustomerSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      customerLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(
      this.attribute_name + " Name",
      "description",
      0,
      false
    ); //1
    this.addColumnDefinition("Phone", "address.phoneNumber1", 0, false); //2
    this.addColumnDefinition("Type", "customerTypeCode", 0, false); //3
    this.addColumnDefinition("Currency", "currencyCode", 0, false); //3
    this.addColumnDefinition("ShipVia", "shipViaCode", 0, false);
    this.addColumnDefinition("PaymentMethod", "paymentMethodCode", 0, false);
    this.addColumnDefinition("PaymentTerm", "paymentTermsCode", 0, false);
  }
  loadCustomerList = (lookup_dialog, pageNumber, searchCriteria) => {
    let cust_criteria = new CustomerSearchCriteria(); //To be fetched from CriteriaHandler
    cust_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      cust_criteria.customerCode = searchCriteria.customerCode;
      cust_criteria.customerCodeContains = searchCriteria.customerCodeContains;
      cust_criteria.customerCodeStartsWith =
        searchCriteria.customerCodeStartsWith;
      cust_criteria.customerNameContains = searchCriteria.customerNameContains;
      cust_criteria.city = searchCriteria.city;
      cust_criteria.country = searchCriteria.country;
      cust_criteria.customerTypeCode = searchCriteria.customerTypeCode;
      cust_criteria.status = searchCriteria.status;
      cust_criteria.contactName = searchCriteria.contactName;
      cust_criteria.dbaName = searchCriteria.dbaName;
      cust_criteria.shipViaCode = searchCriteria.shipViaCode;
      cust_criteria.arTypeCode = searchCriteria.arTypeCode;
      cust_criteria.financialTypeCode = searchCriteria.financialTypeCode;
      cust_criteria.divisionCode = searchCriteria.divisionCode;
      cust_criteria.zip = searchCriteria.zip;
      cust_criteria.phoneNumber = searchCriteria.phoneNumber;
      cust_criteria.customerDeliveryTypeCode =
        searchCriteria.customerDeliveryTypeCode;
    }
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 50; //TODO --> Fetch from Config
    cust_pageList.currentPage = pageNumber;
    cust_pageList.pageNumber = pageNumber;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;

    if (!this.isExcludeMasterCustomer) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        (response) => this.loadCustomerListResponse(response, lookup_dialog),
        this.loadCustomerListError
      );
    } else {
      CustomerService.getCustomerExcludesMasterCustomer(
        cust_requestInput,
        (response) => this.loadCustomerListResponse(response, lookup_dialog),
        this.loadCustomerListError
      );
    }
  };
  loadCustomerListResponse = (response, lookup_dialog) => {
    let customerList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.customerPageList != null &&
      response.data.customerPageList.customers !== null
    ) {
      customerList = response.data.customerPageList.customers;
      totalCount = response.data.customerPageList.totalCount;
      currentPageNumber = response.data.customerPageList.currentPage;
      pageSize = response.data.customerPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = customerList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadCustomerListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.customerCodeContains)) {
      if (!isEmptyString(filterText)) {
        search.customerCodeContains = filterText;
        this.searchCriteria = new CustomerSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadCustomerList(lookup_dialog, pageNumber, search);
    }
  }
}
const CustomerLookupCriteraHandler = (companyCode, customerLookupCriteria) => {
  return class extends React.Component {
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new CustomerSearchCriteria(),
        financialTypes: [],
        customerTypes: [],
        shipViaCodes: [],
        countries: [],
        arTypes: [],
        customerDeliveries: [],
        shipViaPageListForAutoCompleteList: new Array(),
        showAutoCompleteShipViaList: true,
        showAutoCompleteCustomerTypeCodeList: true,
        customerTypeCodePageListForAutoCompleteList: new Array(),
        showAutoCompleteCountryList: true,
        countryPageListForAutoCompleteList: new Array(),
        customerDeliveryTypeCodePageListForAutoCompleteList: new Array(),
        showAutoCompletecustomerDeliveryTypeCodeList: true,
        showAutoCompletefinancialTypeCodeList: true,
        financialTypeCodePageListForAutoCompleteList: new Array(),
        arTypeCodePageListForAutoCompleteList: new Array(),
        showAutoCompleteArTypeCodeList: true,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      const { appData } = this.context;
      const { cache } = appData;
      this.cache = cache;
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.loadCacheDetails();
      this.initLookupHandlers();
    }
    loadCacheDetails = () => {
      // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
      const attribute_cache = { ...this.cache };
      this.state.customerTypes = [];
      let customerTypes = attribute_cache.customerTypes;
      let customerTypes_temp=[];
      customerTypes.map((customerType) => {
        customerTypes_temp.push(customerType);
        this.state.customerTypes=ModuleUtils.isActiveAttribute(customerTypes_temp);
      });
      this.state.shipViaCodes = [];
      let shipViaCodes = attribute_cache.shipVias;
      let shipViaCodes_temp=[];
      shipViaCodes.map((shipViaCode) => {
       shipViaCodes_temp.push(shipViaCode);
         this.state.shipViaCodes=ModuleUtils.isActiveAttribute(shipViaCodes_temp);
      });
      this.state.countries = [];
      let countries = attribute_cache.countries;
      let countries_temp=[];
      countries.map((countryCode) => {
       countries_temp.push(countryCode);
         this.state.countries=ModuleUtils.isActiveAttribute(countries_temp);
      });
      this.state.arTypes = [];
      let arTypes = attribute_cache.arTypes;
      let arTypes_temp=[];
      arTypes.map((arType) => {
       arTypes_temp.push(arType);
         this.state.arTypes=ModuleUtils.isActiveAttribute(arTypes_temp);
      });

      this.state.customerDeliveries = [];
      let customerDeliveries = attribute_cache.customerDeliveries;
      let customerDeliveries_temp=[];
      customerDeliveries.map((customerDelivery) => {
       customerDeliveries_temp.push(customerDelivery);
        this.state.customerDeliveries=ModuleUtils.isActiveAttribute(customerDeliveries_temp);
      });

      this.state.financialTypes = [];
      let financialTypes = attribute_cache.financialTypes;
      let financialTypes_temp=[];
      financialTypes.map((financialType) => {
      financialTypes_temp.push(financialType);
          this.state.financialTypes=ModuleUtils.isActiveAttribute(financialTypes_temp);
      });
    };
    initLookupHandlers = () => {
      let customerTypeLookupHandler = new GenericAttributeLookupHandler(
        this.state.customerTypes,
        "Customer Type"
      );
      this.setState({ customerTypeLookupHandler: customerTypeLookupHandler });
      let countryLookupHandler = new GenericAttributeLookupHandler(
        this.state.countries,
        "Country"
      );
      this.setState({ countryLookupHandler: countryLookupHandler });
      let shipViaLookupHandler = new GenericAttributeLookupHandler(
        this.state.shipViaCodes,
        "ShipVia"
      );
      this.setState({ shipViaLookupHandler: shipViaLookupHandler });
      let customerDeliveryTypeCodeLookupHandler =
        new GenericAttributeLookupHandler(
          this.state.customerDeliveries,
          "Delivery Type"
        );
      this.setState({
        customerDeliveryTypeCodeLookupHandler:
          customerDeliveryTypeCodeLookupHandler,
      });
      let arTypeCodeLookupHandler = new GenericAttributeLookupHandler(
        this.state.arTypes,
        "ArType"
      );
      this.setState({ arTypeCodeLookupHandler: arTypeCodeLookupHandler });
      let financialTypeCodeLookupHandler = new GenericAttributeLookupHandler(
        this.state.financialTypes,
        "Financial Type "
      );
      this.setState({
        financialTypeCodeLookupHandler: financialTypeCodeLookupHandler,
      });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    onArTypeCodeChange = (e) => {
      let arTypeCode = e.target.value;
      this.state.showAutoCompleteArTypeCodeList = true;

      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteArTypeCodeList;

      if (isEmpty(arTypeCode)) {
        this.state.showAutoCompleteArTypeCodeList = false;
        let showAutoCompleteList = this.state.showAutoCompleteArTypeCodeList;
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.arTypeCode = "";

        let suggestion = [];

        this.setState({
          showAutoCompleteArTypeCodeList: showAutoCompleteList,
          searchCriteria: temp_searchCriteria,
          arTypeCodePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && arTypeCode !== "") {
        this.readArTypeCodeBySearchString(arTypeCode);
      }
      if (e.target.name == "arTypeCode") {
        temp_searchCriteria["arTypeCode"] = e.target.value;
        let arTypeCode_List = this.state.arTypes;
        arTypeCode_List.map((arTypeCode) => {
          if (arTypeCode.code == e.target.value) {
            temp_searchCriteria["arTypeCode"] = arTypeCode.code;

            this.state.showAutoCompleteArTypeCodeList = false;
            let showAutoCompleteList =
              this.state.showAutoCompleteArTypeCodeList;
            this.setState({
              showAutoCompleteArTypeCodeList: showAutoCompleteList,
            });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    readArTypeCodeBySearchString(searchString) {
      let arTypeCodeData = this.state.arTypes;
      let simpleAutoCompleteList = new Array();
      if (arTypeCodeData.length > 0 && arTypeCodeData != null) {
        arTypeCodeData.map((arTypeCodeDatas) => {
          let simpleItemBean = {
            code: arTypeCodeDatas.code,
            description: arTypeCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletearTypeCodeLists) =>
          simpleAutoCompletearTypeCodeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        arTypeCodePageListForAutoCompleteList: filteredSuggestions,
      });
    }
    arTypeCodeEnterKeyEvent = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      let arTypeCode = e.target.value;

      temp_searchCriteria["arTypeCode"] = arTypeCode;
      let arTypeCodeList = this.state.arTypes;
      let arTypeCodeBean = null;
      arTypeCodeList.map((arTypeCode_List) => {
        if (arTypeCode_List.code == e.target.value) {
          arTypeCodeBean = arTypeCode_List;
        }
      });
      if (!isEmpty(arTypeCodeBean)) {
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.arTypeCode = arTypeCodeBean.code;

        this.setState({
          searchCriteria: temp_searchCriteria,
          arTypeCodePageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteArTypeCodeList = (showAutoCompleteArTypeCodeList) => {
      this.setState({
        showAutoCompleteArTypeCodeList: showAutoCompleteArTypeCodeList,
      });
    };
    oncustomerDeliveryTypeCodeChange = (e) => {
      let customerDeliveryTypeCode = e.target.value;
      this.state.showAutoCompleteArTypeCodeList = true;

      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList =
        this.state.showAutoCompletecustomerDeliveryTypeCodeList;

      if (isEmpty(customerDeliveryTypeCode)) {
        this.state.showAutoCompleteShipViaList = false;
        let showAutoCompleteList =
          this.state.showAutoCompletecustomerDeliveryTypeCodeList;
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.customerDeliveryTypeCode = "";

        let suggestion = [];

        this.setState({
          showAutoCompletecustomerDeliveryTypeCodeList: showAutoCompleteList,
          searchCriteria: temp_searchCriteria,
          customerDeliveryTypeCodePageListForAutoCompleteList: suggestion,
        });
      } else if (
        showAutoCompleteList === true &&
        customerDeliveryTypeCode !== ""
      ) {
        this.readcustomerDeliveryTypeCodeBySearchString(
          customerDeliveryTypeCode
        );
      }
      if (e.target.name == "customerDeliveryTypeCode") {
        temp_searchCriteria["customerDeliveryTypeCode"] = e.target.value;
        let customerDeliveryTypeCode_List = this.state.customerDeliveries;
        customerDeliveryTypeCode_List.map((customerDeliveryTypeCode) => {
          if (customerDeliveryTypeCode.code == e.target.value) {
            temp_searchCriteria["customerDeliveryTypeCode"] =
              customerDeliveryTypeCode.code;

            this.state.showAutoCompletecustomerDeliveryTypeCodeList = false;
            let showAutoCompleteList =
              this.state.showAutoCompletecustomerDeliveryTypeCodeList;
            this.setState({
              showAutoCompletecustomerDeliveryTypeCodeList:
                showAutoCompleteList,
            });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    readcustomerDeliveryTypeCodeBySearchString(searchString) {
      let customerDeliveryTypeCodeData = this.state.customerDeliveries;

      let simpleAutoCompleteList = new Array();
      if (
        customerDeliveryTypeCodeData.length > 0 &&
        customerDeliveryTypeCodeData != null
      ) {
        customerDeliveryTypeCodeData.map((customerDeliveryTypeCodeDatas) => {
          let simpleItemBean = {
            code: customerDeliveryTypeCodeDatas.code,
            description: customerDeliveryTypeCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletecustomerDeliveryTypeCodeLists) =>
          simpleAutoCompletecustomerDeliveryTypeCodeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        customerDeliveryTypeCodePageListForAutoCompleteList:
          filteredSuggestions,
      });
    }
    customerDeliveryTypeCodeEnterKeyEvent = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      let customerDeliveryTypeCode = e.target.value;

      temp_searchCriteria["customerDeliveryTypeCode"] = e.target.value;
      let customerDeliveryTypeCodeList = this.state.customerDeliveries;
      let customerDeliveryTypeCodeBean = null;
      customerDeliveryTypeCodeList.map((customerDeliveryTypeCode_List) => {
        if (customerDeliveryTypeCode.code == e.target.value) {
          customerDeliveryTypeCodeBean = customerDeliveryTypeCode_List;
        }
      });
      if (!isEmpty(customerDeliveryTypeCodeBean)) {
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.customerDeliveryTypeCode =
          customerDeliveryTypeCodeBean.code;

        this.setState({
          searchCriteria: temp_searchCriteria,
          customerDeliveryTypeCodePageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompletecustomerDeliveryTypeCodeList = (
      showAutoCompletecustomerDeliveryTypeCodeList
    ) => {
      this.setState({
        showAutoCompletecustomerDeliveryTypeCodeList:
          showAutoCompletecustomerDeliveryTypeCodeList,
      });
    };
    onfinancialTypeCodeChange = (e) => {
      let financialTypeCode = e.target.value;
      this.state.showAutoCompletefinancialTypeCodeList = true;

      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList =
        this.state.showAutoCompletefinancialTypeCodeList;

      if (isEmpty(financialTypeCode)) {
        this.state.showAutoCompletefinancialTypeCodeList = false;
        let showAutoCompleteList =
          this.state.showAutoCompletefinancialTypeCodeList;
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.financialTypeCode = "";

        let suggestion = [];

        this.setState({
          showAutoCompletefinancialTypeCodeList: showAutoCompleteList,
          searchCriteria: temp_searchCriteria,
          financialTypeCodePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && financialTypeCode !== "") {
        this.readfinancialTypeCodeBySearchString(financialTypeCode);
      }
      if (e.target.name == "financialTypeCode") {
        temp_searchCriteria["financialTypeCode"] = e.target.value;
        let financialTypeCode_List = this.state.financialTypes;
        financialTypeCode_List.map((financialTypeCode) => {
          if (financialTypeCode.code == e.target.value) {
            temp_searchCriteria["financialTypeCode"] = financialTypeCode.code;

            this.state.showAutoCompletefinancialTypeCodeList = false;
            let showAutoCompleteList =
              this.state.showAutoCompletefinancialTypeCodeList;
            this.setState({
              showAutoCompletefinancialTypeCodeList: showAutoCompleteList,
            });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    readfinancialTypeCodeBySearchString(searchString) {
      let financialTypeCodeData = this.state.financialTypes;
      let simpleAutoCompleteList = new Array();
      if (financialTypeCodeData.length > 0 && financialTypeCodeData != null) {
        financialTypeCodeData.map((financialTypeCodeDatas) => {
          let simpleItemBean = {
            code: financialTypeCodeDatas.code,
            description: financialTypeCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletefinancialTypeCodeLists) =>
          simpleAutoCompletefinancialTypeCodeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        financialTypeCodePageListForAutoCompleteList: filteredSuggestions,
      });
    }
    financialTypeCodeEnterKeyEvent = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      let financialTypeCode = e.target.value;

      temp_searchCriteria["financialTypeCode"] = financialTypeCode;
      let financialTypeCodeList = this.state.financialTypes;
      let financialTypeCodeBean = null;
      financialTypeCodeList.map((financialTypeCode_List) => {
        if (financialTypeCode_List.code == e.target.value) {
          financialTypeCodeBean = financialTypeCode_List;
        }
      });
      if (!isEmpty(financialTypeCodeBean)) {
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.financialTypeCode = financialTypeCodeBean.code;

        this.setState({
          searchCriteria: temp_searchCriteria,
          financialTypeCodePageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompletefinancialTypeCodeList = (
      showAutoCompletefinancialTypeCodeList
    ) => {
      this.setState({
        showAutoCompletefinancialTypeCodeList:
          showAutoCompletefinancialTypeCodeList,
      });
    };
    onCustomerTypeCodeChange = (e) => {
      let customerTypeCode = e.target.value;
      this.state.showAutoCompleteCustomerTypeCodeList = true;

      let temp_searchcriteria = this.state.searchCriteria;
      let showAutoCompleteList =
        this.state.showAutoCompleteCustomerTypeCodeList;

      if (isEmpty(customerTypeCode)) {
        this.state.showAutoCompleteCustomerTypeCodeList = false;
        let showAutoCompleteList =
          this.state.showAutoCompleteCustomerTypeCodeList;
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.customerTypeCode = "";

        let suggestion = [];

        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchcriteria,
          customerTypeCodePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && customerTypeCode !== "") {
        this.readCustomerTypeCodeBySearchString(customerTypeCode);
      }
      if (e.target.name == "customerTypeCode") {
        temp_searchcriteria["customerTypeCode"] = e.target.value;
        let customerTypeCode_List = this.state.customerTypes;
        customerTypeCode_List.map((customerTypeCode) => {
          if (customerTypeCode.code == e.target.value) {
            temp_searchcriteria["customerTypeCode"] = customerTypeCode.code;

            this.state.showAutoCompleteCustomerTypeCodeList = false;
            let showAutoCompleteList =
              this.state.showAutoCompleteCustomerTypeCodeList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchcriteria });
    };
    readCustomerTypeCodeBySearchString(searchString) {
      let customerTypeCodeData = this.state.customerTypes;
      let simpleAutoCompleteList = new Array();
      if (customerTypeCodeData.length > 0 && customerTypeCodeData != null) {
        customerTypeCodeData.map((customerTypeCodeDatas) => {
          let simpleItemBean = {
            code: customerTypeCodeDatas.code,
            description: customerTypeCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteCustomerTypeCodeLists) =>
          simpleAutoCompleteCustomerTypeCodeLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        customerTypeCodePageListForAutoCompleteList: filteredSuggestions,
      });
    }
    customerTypeCodeEnterKeyEvent = (e) => {
      let temp_searchcriteria = this.state.searchCriteria;
      let customerTypeCode = e.target.value;

      temp_searchcriteria["customerTypeCode"] = customerTypeCode;
      let CustomerTypeCode_List = this.state.customerTypes;
      let CustomerTypeCodeBean = null;
      CustomerTypeCode_List.map((customerTypeCode) => {
        if (customerTypeCode.code == e.target.value) {
          CustomerTypeCodeBean = customerTypeCode;
        }
      });
      if (!isEmpty(CustomerTypeCodeBean)) {
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.customerTypeCode = CustomerTypeCodeBean.code;

        this.setState({
          searchCriteria: temp_searchcriteria,
          customerTypeCodePageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteCustomerTypeCodeList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteCustomerTypeCodeList: showAutoCompleteList,
      });
    };
    onCountryChange = (e) => {
      let country = e.target.value;
      this.state.showAutoCompleteCountryList = true;

      let temp_searchcriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;

      if (isEmpty(country)) {
        this.state.showAutoCompleteCountryList = false;
        let showAutoCompleteList = this.state.showAutoCompleteCountryList;
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.country = "";

        let suggestion = [];

        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchcriteria,
          countryPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && country !== "") {
        this.readcountryBySearchString(country);
      }
      if (e.target.name == "country") {
        temp_searchcriteria["country"] = e.target.value;
        let country_List = this.state.countries;
        country_List.map((country) => {
          if (country.code == e.target.value) {
            temp_searchcriteria["country"] = country.code;

            this.state.showAutoCompleteCountryList = false;
            let showAutoCompleteList = this.state.showAutoCompleteCountryList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchcriteria });
    };
    readcountryBySearchString(searchString) {
      let countryData = this.state.countries;
      let simpleAutoCompleteList = new Array();
      if (countryData.length > 0 && countryData != null) {
        countryData.map((countryDatas) => {
          let simpleItemBean = {
            code: countryDatas.code,
            description: countryDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletecountryLists) =>
          simpleAutoCompletecountryLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        countryPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    countryEnterKeyEvent = (e) => {
      let temp_searchcriteria = this.state.searchCriteria;
      let country = e.target.value;

      temp_searchcriteria["country"] = country;
      let country_List = this.state.countries;
      let countryBean = null;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          countryBean = country;
        }
      });
      if (!isEmpty(countryBean)) {
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.country = countryBean.code;

        this.setState({
          searchCriteria: temp_searchcriteria,
          countryPageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteCountryList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
    };
    onShipViaChange = (e) => {
      let shipViaCode = e.target.value;
      this.state.showAutoCompleteShipViaList = true;

      let temp_searchcriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

      if (isEmpty(shipViaCode)) {
        this.state.showAutoCompleteShipViaList = false;
        let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.shipViaCode = "";

        let suggestion = [];

        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchcriteria,
          shipViaPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && shipViaCode !== "") {
        this.readShipViaBySearchString(shipViaCode);
      }
      if (e.target.name == "shipViaCode") {
        temp_searchcriteria["shipViaCode"] = e.target.value;
        let shipViaCode_List = this.state.shipViaCodes;
        shipViaCode_List.map((shipViaCode) => {
          if (shipViaCode.code == e.target.value) {
            temp_searchcriteria["shipViaCode"] = shipViaCode.code;

            this.state.showAutoCompleteShipViaList = false;
            let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchcriteria });
    };
    readShipViaBySearchString(searchString) {
      let shipViaCodeData = this.state.shipViaCodes;
      let simpleAutoCompleteList = new Array();
      if (shipViaCodeData.length > 0 && shipViaCodeData != null) {
        shipViaCodeData.map((shipViaCodeDatas) => {
          let simpleItemBean = {
            code: shipViaCodeDatas.code,
            description: shipViaCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteShipViaLists) =>
          simpleAutoCompleteShipViaLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        shipViaPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    shipViaEnterKeyEvent = (e) => {
      let temp_searchcriteria = this.state.searchCriteria;
      let shipViaCode = e.target.value;

      temp_searchcriteria["shipViaCode"] = shipViaCode;
      let shipViaList = this.state.shipViaCodes;
      let shipViaBean = null;
      shipViaList.map((shipVia_List) => {
        if (shipVia_List.code == e.target.value) {
          shipViaBean = shipVia_List;
        }
      });
      if (!isEmpty(shipViaBean)) {
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.shipViaCode = shipViaBean.code;

        this.setState({
          searchCriteria: temp_searchcriteria,
          shipViaPageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteShipViaList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerCode"
                  name="customerCode"
                  onChange={this.onChange}
                  value={searchCriteria.customerCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerCode StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerCodeStartsWith"
                  name="customerCodeStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.customerCodeStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerCode Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerCodeContains"
                  name="customerCodeContains"
                  onChange={this.onChange}
                  value={searchCriteria.customerCodeContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerName Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerNameContains"
                  name="customerNameContains"
                  onChange={this.onChange}
                  value={searchCriteria.customerNameContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Division</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="divisionCode"
                  name="divisionCode"
                  onChange={this.onChange}
                  value={searchCriteria.divisionCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Country</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="country"
                  name="country"
                  onChange={this.onCountryChange}
                  value={searchCriteria.country}
                  lookupRequired={true}
                  lookupHandler={this.state.countryLookupHandler}
                  enterKeyEventHandler={this.countryEnterKeyEvent}
                  autoCompleteListData={
                    this.state.countryPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteCountryList}
                  showAutoCompleteList={this.state.showAutoCompleteCountryList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PriceType</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerTypeCode"
                  name="customerTypeCode"
                  onChange={this.onCustomerTypeCodeChange}
                  value={searchCriteria.customerTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerTypeLookupHandler}
                  enterKeyEventHandler={this.customerTypeCodeEnterKeyEvent}
                  autoCompleteListData={
                    this.state.customerTypeCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteCustomerTypeCodeList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteCustomerTypeCodeList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Active</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"I"}>InActive</option>
                  <option value={"A"}>Active</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>FinancialType</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="financialTypeCode"
                  name="financialTypeCode"
                  onChange={this.onfinancialTypeCodeChange}
                  value={searchCriteria.financialTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.financialTypeCodeLookupHandler}
                  enterKeyEventHandler={this.financialTypeCodeEnterKeyEvent}
                  autoCompleteListData={
                    this.state.financialTypeCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletefinancialTypeCodeList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompletefinancialTypeCodeList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Contact</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="contactName"
                  name="contactName"
                  onChange={this.onChange}
                  value={searchCriteria.contactName}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>TelePhone Number</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="phoneNumber"
                  name="phoneNumber"
                  onChange={this.onChange}
                  value={searchCriteria.phoneNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Zip</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="zip"
                  name="zip"
                  onChange={this.onChange}
                  value={searchCriteria.zip}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>AR Type</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="arTypeCode"
                  name="arTypeCode"
                  onChange={this.onArTypeCodeChange}
                  value={searchCriteria.arTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.arTypeCodeLookupHandler}
                  enterKeyEventHandler={this.arTypeCodeEnterKeyEvent}
                  autoCompleteListData={
                    this.state.arTypeCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteArTypeCodeList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteArTypeCodeList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>ShipVia</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="shipViaCode"
                  name="shipViaCode"
                  onChange={this.onShipViaChange}
                  value={searchCriteria.shipViaCode}
                  lookupRequired={true}
                  lookupHandler={this.state.shipViaLookupHandler}
                  enterKeyEventHandler={this.shipViaEnterKeyEvent}
                  autoCompleteListData={
                    this.state.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                  showAutoCompleteList={this.state.showAutoCompleteShipViaList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>DBA Name</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="dbaName"
                  name="dbaName"
                  onChange={this.onChange}
                  value={searchCriteria.dbaName}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Delivery Type</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerDeliveryTypeCode"
                  name="customerDeliveryTypeCode"
                  onChange={this.oncustomerDeliveryTypeCodeChange}
                  value={searchCriteria.customerDeliveryTypeCode}
                  lookupRequired={true}
                  lookupHandler={
                    this.state.customerDeliveryTypeCodeLookupHandler
                  }
                  enterKeyEventHandler={
                    this.customerDeliveryTypeCodeEnterKeyEvent
                  }
                  autoCompleteListData={
                    this.state
                      .customerDeliveryTypeCodePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletecustomerDeliveryTypeCodeList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompletecustomerDeliveryTypeCodeList
                  }
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
